module.exports = __webpack_public_path__ + "img/news-image5.d7eaa589.png";